// Interface
export interface DailyGift {
    day: number;
    gift_rate: number;
    turnover_times: number;
    createTime: string;
    activeStatus: number;
    dayOne: number;
    dayTwo: number;
    dayThree: number;
    dayFour: number;
    dayFive: number;
    daySix: number;
    daySeven: number;
    status: number;
    availableAmount: number;
    givenAmount: number;
    rewards: FutureRewards[];
}
export interface FutureRewards {
    amount: string,
    date: string
}

export interface RechargeGiftData {
    todayRechargeGiftDetails : DailyGift
    historyList : DailyGift[]
    activityDescription : string[]
    total : number
    pageNum : number
    pageSize : number
    weeklyRechargeGiftList : DailyGift[]
    cashbackTotal : number
    futureRewards : FutureRewards[]
    bannerIcon : string
}

// Constant

export const PAGE_SIZE = 20

export const DAY_COUNT = 11